import(/* webpackMode: "eager", webpackExports: ["BaseLayout"] */ "/home/runner/_work/nvs-code/nvs-code/web/app/components/BaseLayout.tsx");
